import React, { useState, useEffect, useContext, useRef } from "react";
import "./Registration_Process.css";
import { Registrations } from "../../../utils/apis/subsidy-policy/SubsidyPolicy";

const Registration_Process = () => {
  const steps = [
    {
      id: "01",
      title: "Step 01",
      text: (
        <>
          Visit the website at <br />
          <a
            href="https://pmsuryaghar.gov.in/"
            target="_blank"
            rel="noreferrer"
          >
            https://pmsuryaghar.gov.in/
          </a>
        </>
      ),
      bg: "step_blue",
      dot: "dot_blue",
      line: "line_blue", // ✅ ADD THIS
    },
    {
      id: "02",
      title: "Step 02",
      text: (
        <>
          Go to consumer page & select <b>“Apply Now”</b> (or) Open the Login
          dropdown menu and select <b>“Consumer Login”</b>
        </>
      ),
      bg: "step_orange",
      dot: "dot_orange",
      line: "line_orange", // ✅ ADD
    },
    {
      id: "03",
      title: "Step 03",
      text: (
        <>
          Enter valid Registered Consumer Mobile Number for Registration, Enter
          valid Captcha & Select <b>“Yes</b>, I have read all the guidelines of
          PM Surya Ghar Muft Bijli Yojana.”, then <b>Click on “Verify”</b>
        </>
      ),
      bg: "step_green",
      dot: "dot_green",
      line: "line_green", // ✅ ADD
    },
    {
      id: "04",
      title: "Step 04",
      text: (
        <>
          Enter valid Mobile OTP received through SMS and then click on
          <b> “Login”</b>.
        </>
      ),
      bg: "step_gray",
      dot: "dot_gray",
      line: "line_gray", // ✅ ADD
    },
    {
      id: "05",
      title: "Step 05",
      text: (
        <>
          After successful Login, then{" "}
          <b>Enter Profile details of Registration</b>
          Consumer by entering valid Consumer Name, E-Mail, Address, State,
          District and PIN Code and then click on <b>“Save”</b>.
        </>
      ),
      bg: "step_yellow",
      dot: "dot_yellow",
      line: "line_yellow", // ✅ ADD
    },
    {
      id: "06",
      title: "Step 06",
      text: (
        <>
          <b>Apply for Solar Rooftop</b> by selecting State, District, Utility,
          entering the consumer account number, fetching details, and submitting
          the application.
        </>
      ),
      bg: "step_purple",
      dot: "dot_purple",
      line: "line_purple", // ✅ ADD
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [registration, setRegistration] = useState([]);

  const getRegistration = async () => {
    const res = await Registrations();

    if (res?.success) {
      setRegistration(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getRegistration();
  }, []);

  return (
    <section className="Registration_Process">
      <div className="container">
        <div className="Registration_Process_header_holder">
          <h5 className="Registration_Process_title">
            Consumer Registration Process
          </h5>
          <p className="Registration_Process_subtitle">
            Submit your details and move one step closer to Flowers.
          </p>
        </div>

        <div className="step_section">
          <div className="row justify-content-center">
            {registration.map((item, index) => {
              const stepStyle = steps[index] || {};

              return (
                <div
                  className="col-lg-4 col-md-6 col-sm-6 col-12 mb-4"
                  key={index}
                >
                  <div className={`step_card ${stepStyle.bg}`}>
                    <div className="step_header">
                      <h5>{item.name}</h5>

                      <div
                        className={`step_dot ${stepStyle.dot} ${stepStyle.line}`}
                      ></div>
                    </div>

                    <div className="step_content">
                      <p>{htmlToReactParser.parse(item.description)}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Registration_Process;
